import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-qr-confirm-modal',
  templateUrl: './qr-confirm-modal.component.html',
  styleUrls: ['./qr-confirm-modal.component.css']
})
export class QrConfirmModalComponent {
  @ViewChild('confirmModal') confirmModal: ModalDirective;

  @Input() title: string = 'Xác nhận';
  @Input() message: string = 'Bạn có chắc chắn muốn thực hiện hành động này?';
  @Input() confirmText: string = 'Đồng ý';
  @Input() cancelText: string = 'Hủy bỏ';
  @Input() isDanger: boolean = true;
  @Input() isLoading: boolean = false;

  @Output() onConfirm = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();

  show() {
    this.confirmModal.show();
  }

  hide() {
    this.confirmModal.hide();
  }

  confirm() {
    this.onConfirm.emit();
  }

  cancel() {
    this.onCancel.emit();
    this.hide();
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/ui/qr-confirm-modal/qr-confirm-modal.component.ts